import { Box, Card, InfoBanner, Typography, useTheme } from "@compass/core";
import {
  MatchReportActualMatch,
  MatchReportActualYearly,
  MatchReportAllPartners,
  MatchReportContributorDetail,
  MatchReportContributorSummary,
  MatchReportNonPersonnelDetail,
} from "generated/openApi";
import "moment-timezone";
import { MatchReportSelection, MatchReportType } from "./MatchReportPage";

import { ActualMatch } from "./ActualMatch/ActualMatch";
import { ActualYearly } from "./ActualYearly/ActualYearly";
import { AllPartners } from "./AllPartners/AllPartners";
import { ContributorDetail } from "./ContributorDetail/ContributorDetail";
import { ContributorSummary } from "./ContributorSummary/ContributorSummary";
import { NonPersonnelDetail } from "./NonPersonnelDetail/NonPersonnelDetail";

export const GeneratedReport = (props: {
  selectedReportType: MatchReportType | undefined;
  reportTypes: MatchReportSelection[];
  contributorDetail: MatchReportContributorDetail | undefined;
  nonPersonnelDetail: MatchReportNonPersonnelDetail | undefined;
  contributorSummary: MatchReportContributorSummary | undefined;
  allPartners: MatchReportAllPartners | undefined;
  actualYearly: MatchReportActualYearly | undefined;
  actualMatch: MatchReportActualMatch | undefined;
}) => {
  const theme = useTheme();
  const reportType = props.reportTypes.find((x) => x.name === props.selectedReportType);
  const isDirectPdf = reportType?.generateTypes.includes("direct-pdf");

  const renderPreReport = () => {
    const reportType = props.reportTypes.find((x) => x.name === props.selectedReportType);
    const isDirectPdf = reportType?.generateTypes.includes("direct-pdf");

    return (
      <Box display="flex" height="100%" alignItems="center" justifyContent={"center"}>
        <Typography variant="h5" fontWeight={theme.typography.fontWeightLight}>
          {isDirectPdf ? "Report will be opened directly in PDF. " : "Report will be generated on screen here"}
        </Typography>
      </Box>
    );
  };

  return (
    <Card header={props.selectedReportType} fullHeight>
      {isDirectPdf ? (
        renderPreReport()
      ) : (
        <>
          {props.selectedReportType === "Contributor Details" && (
            <>
              {props.contributorDetail ? (
                <ContributorDetail report={props.contributorDetail} />
              ) : (
                <>{renderPreReport()}</>
              )}
            </>
          )}

          {props.selectedReportType === "Non-Personnel Details" && (
            <>
              {props.nonPersonnelDetail ? (
                <NonPersonnelDetail report={props.nonPersonnelDetail} />
              ) : (
                <>{renderPreReport()}</>
              )}
            </>
          )}

          {props.selectedReportType === "Contributor Summary" && (
            <>
              {props.contributorSummary ? (
                <ContributorSummary report={props.contributorSummary} />
              ) : (
                <>{renderPreReport()}</>
              )}
            </>
          )}

          {props.selectedReportType === "All Partners" && (
            <>
              {props.allPartners ? <AllPartners report={props.allPartners} /> : <>{renderPreReport()}</>}
            </>
          )}

          {props.selectedReportType === "Actual Yearly" && (
            <>
              {props.actualYearly ? (
                <ActualYearly report={props.actualYearly} />
              ) : (
                <>{renderPreReport()}</>
              )}
              <InfoBanner title="">
                <Typography variant="caption" color="primary">Year 7 includes no-cost extension if applicable</Typography>
              </InfoBanner>
            </>
          )}

          {props.selectedReportType === "Actual Match" && (
            <>
              {props.actualMatch ? <ActualMatch report={props.actualMatch} /> : <>{renderPreReport()}</>}
            </>
          )}
        </>
      )}
    </Card>
  );
};
